import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BfFlex, BfIcon, IconType, Sizes } from '@finetic/bikefitting-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectionDetailsItem',
  props: {
    icon: {},
    label: {},
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfFlex), {
    align: "center",
    class: "selection-details-item"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BfIcon), {
        icon: __props.icon,
        size: _unref(Sizes).xxl,
        type: _unref(IconType).Contained,
        "contained-padding": _unref(Sizes).xxs
      }, null, 8, ["icon", "size", "type", "contained-padding"]),
      _createElementVNode("span", null, [
        _createElementVNode("b", null, _toDisplayString(__props.label) + ":", 1),
        _createTextVNode(" " + _toDisplayString(__props.value), 1)
      ])
    ]),
    _: 1
  }))
}
}

})